import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { ChevronDownUnsorted, ChevronDown, ChevronUp } from "@dippi/icons";
import { useTableHelper } from "./hooks";
import useQueryMembers from "@/hooks/queries/useQueryMembers";

const Table: React.FC = () => {
    const { data, isFetching } = useQueryMembers();
    const { columns, rows, getRowSpacing } = useTableHelper();

    return (
        <DataGrid
            rows={rows(data!)}
            columns={columns()}
            loading={!data && isFetching}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 5,
                    },
                },
            }}
            pageSizeOptions={[5]}
            disableColumnFilter={true}
            disableColumnSelector={true}
            showColumnVerticalBorder={true}
            disableRowSelectionOnClick={true}
            disableColumnMenu={true}
            hideFooter={true}
            hideFooterSelectedRowCount={true}
            columnHeaderHeight={40}
            getRowHeight={() => "auto"}
            getRowSpacing={getRowSpacing}
            slots={{
                columnSortedAscendingIcon: () => <ChevronUp />,
                columnSortedDescendingIcon: () => <ChevronDown />,
                columnUnsortedIcon: () => <ChevronDownUnsorted />,
            }}
            sx={{ padding: "5px", height: "unset" }}
        />
    );
};

export default Table;
